import React, { createContext, useState, useContext, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { getFromLocalStorage, removeFromLocalStorage, setToLocalStorage, showSuccessToast } from "src/lib/utils";
import { useMutation, useQuery } from "@tanstack/react-query";
import { logoutFn, validateToken } from "src/api";

const AuthContext = createContext({
	user: {},
	logout: () => {},
	setUser: () => {},
	isAuthenticated: false,
});

export const AuthProvider = () => {
	const [user, setUser] = useState(() => getFromLocalStorage("user"));

	useEffect(() => {
		setToLocalStorage("user", user);
	}, [user]);

	const { mutateAsync } = useMutation(logoutFn, {
		onSuccess: ({ message }) => {
			showSuccessToast(message ?? "Logged out successfully");
		},
	});

	const logout = async () => {
		await mutateAsync();
		setUser(null);
		removeFromLocalStorage("access_token", "user", "selectedBusiness", "selectedChild");
	};

	const { data } = useQuery({
		queryKey: ["user"],
		queryFn: validateToken,
		enabled: !!user,
		refetchInterval: 5 * 60 * 1000,
	});

	useEffect(() => {
		const resUser = data?.data?.user;
		if (resUser) {
			setUser(resUser);
		}
	}, [data]);

	return (
		<AuthContext.Provider value={{ isAuthenticated: !!user, logout, user, setUser }}>
			<Outlet />
		</AuthContext.Provider>
	);
};

export const useAuth = () => useContext(AuthContext);
